/*
This file is located in the main branch
Last time the file was updated (UTC): [11.12.2024 08:50:34]
Permissions to update outside the main branch: [false]
*/

import { Props, PropsProps, useCondition } from '@finbeat/react-toolkit';
import { useGeneralSettingsContext } from 'providers/GeneralSettingsProvider';
import { FieldValues } from 'react-hook-form';
import Environment from 'utils/environmentUtils';
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker';
import DatePickerHeaderNova from '../BODatePicker/Headers/DatePickerHeader.nova';

export const BOProps = <TFieldValues extends FieldValues>(
    props: Omit<
        PropsProps<TFieldValues>,
        'displayDateFormat' | 'displayDateTimeFormat' | 'environmentFullName'
    >
) => {
    const { dateFormat, dateTimeFormat, designType } = useGeneralSettingsContext();

    const renderCustomHeader = useCondition(designType, { nova: NovaHeader }, undefined);
    return (
        <Props
            {...props}
            displayDateFormat={dateFormat}
            displayDateTimeFormat={dateTimeFormat}
            renderCustomDatePickerHeader={renderCustomHeader}
            environmentFullName={Environment.GetEnvironmentFullName()}
        />
    );
};

const NovaHeader = (props: ReactDatePickerCustomHeaderProps) => <DatePickerHeaderNova {...props} />;
